const { loadFromLocalStorage, saveToLocalStorage } = require('./utils/localStorageUtils')

const VERSION = '1'
const VERSION_KEY = 'storageVersion'

export function init() {
  if (loadFromLocalStorage(VERSION_KEY) !== VERSION) {
    try {
      window.localStorage.clear()
    } catch (e) {
      // do nothing
    }
    saveToLocalStorage(VERSION_KEY, VERSION)
  }
}
